export const iconFontAwesomeUsersPeoplePersonFallingBurst = (
	<i className="fa-solid fa-person-falling-burst"></i>
);
